import { Typography, Grid2 } from '@mui/material'
import { Link } from 'react-router-dom'
import CommonNodeSignUpForm from './CommonNodeSignUpForm';

const TrainerSignUpForm= () => {
    
    const bottomLine = (
        <Grid2 children size={12} display={"flex"} justifyContent={"center"}>
            <Typography variant='body2' fontSize={"12px"}>Do you have an account ? </Typography>  
            <Link to={"/TrainerLogin"}><Typography variant='body2' fontSize={"12px"} color='red.main'> Log In</Typography></Link>
        </Grid2>
    );

    return <CommonNodeSignUpForm role={"trainer"}  bottomLine={bottomLine} signupRoute={"trainerUp/signup"} loginRoute={"trainerUp/login"} allUserDetailList={{}} />  
}

export default TrainerSignUpForm





